module.exports = __webpack_public_path__ + "static/media/Div-Plugin.0b709175.pdf";